{
  "#WWS_WARENUEBERNAHME": {
    "UEBERSICHT": {
      "TITEL_OFFENE_WARENUEBERNAHMEN": "OFFENE WARENÜBERNAHMEN",
      "LABEL_OFFENE_WARENUEBERNAHMEN": "Offene Warenübernahmen",
      "LABEL_ANWENDER": "Anwender:",
      "LABEL_LIEFERSCHEINNUMMER": "Lieferscheinnummer",
      "LABEL_BESTELLUNG": "Bestellung",
      "LABEL_BEARBEITET_VON": "bearbeitet von:",
      "LABEL_BESTELLUNG_ABBUCHEN": "Bestellung abbuchen"
    },
    "DETAIL": {
      "TITEL_WARENUEBERNAHME": "Warenübernahme",
      "TITEL_POSITIONEN": "POSITIONEN",
      "LABEL_OFFEN": "Offen",
      "LABEL_ERLEDIGT": "Erledigt",
      "LABEL_EMBALLAGEN_HINZUFUEGEN": "Emballagen hinzufügen",
      "LABEL_FOTOS_SPEICHERN": "Fotos speichern",
      "LABEL_ABSCHLIESSEN": "Abschließen",
      "LABEL_OFFENE_POSITIONEN": "Offene Positionen",
      "LABEL_ERLEDIGTE_POSITIONEN": "Erledigte Positionen",
      "LABEL_ALLE_POSITIONEN": "Alle Positionen",
      "LABEL_EKBARCODE": "Barcode verknüpfen (EK)",
      "TITEL_LAGERPLATZ_AUSWAHL": "Lagerplatz Auswahl",
      "MESSAGES": {
        "TITEL_WARENUEBERNAHME_ABGESCHLOSSEN": "Warenübernahme abgeschlossen",
        "MESSAGE_WARENUEBERNAHME_ABGESCHLOSSEN": "Die Warenübernahme wurde erfoglreich abgeschlossen",
        "TITEL_POSITION_GEOEFFNET": "Position geöffnet",
        "MESSAGE_POSITION_GEOEFFNET": "Die erledigte Position wurde auf offen gesetzt",
        "TITEL_POSITION_ERLEDIGT": "Position erledigt",
        "MESSAGE_POSITION_ERLEDIGT": "Die offene Position wurde auf erledigt gesetzt",
        "TITEL_EMBALLAGE_HINZUGEFUEGT": "Emballage hinzugefügt",
        "MESSAGE_EMBALLAGE_HINZUGEFUEGT": "Die ausgewählte Emballage wurde erfoglreich hinzugefügt",
        "TITEL_EMBALLAGE_GELOESCHT": "Emballage gelöscht",
        "MESSAGE_EMBALLAGE_GELOESCHT": "Die ausgewählte Emballage wurde erfoglreich gelöscht"
      }
    },
    "BESTELLUNG":  {
      "TITEL_BESTELLUNG_UEBERNAHME": "Bestellung Übernahme",
      "LABEL_OFFENE_BESTELLUNG": "offene Bestellung",
      "LABEL_OFFENE_BESTELLUNGEN": "offene Bestellungen",
      "LABEL_BESTELLNUMMER": "Bestellnummer:",
      "LABEL_BESTELLUNG_UEBERNEHMEN": "Bestellung übernehmen",
      "LABEL_ENTHALTENE_BEWEGUNG": "Bewegung",
      "LABEL_ENTHALTENE_BEWEGUNGEN": "Bewegungen",
      "LABEL_UEBERNEHMEN": "Bestellungen übernehmen",
      "MESSAGES": {
        "TITEL_BESTELLUNG_ABGESCHLOSSEN": "Bestellung abgeschlossen",
        "MESSAGE_BESTELLUNG_ABGESCHLOSSEN": "Die Bestellung wurde erfolgreich übernommen"
      }
    },
    "BEWEGUNG": {
      "LABEL_LAGER": "Lagerplatz",
      "LABEL_AUFTRAG": "Auftrag:",
      "LABEL_KUNDE": "Kunde:",
      "LABEL_ADRESSE": "Adresse:",
      "LABEL_ARTIKELNUMMER": "Art.Nr:",
      "LABEL_LIEFERANT_ARTIKELNUMMER": "Lief.-Art.Nr:",
      "LABEL_EAN": "EAN:",
      "LABEL_ERLEDIGT_MARKIEREN": "Als erledigt markieren",
      "LABEL_OFFEN_MARKIEREN": "Als offen markieren",
      "LABEL_KEINE_BEWEGUNGEN": "Keine Bewegungen für den ausgewählten Filter"
    },
    "KOPFDATEN": {
      "TITEL_KOPFDATEN": "KOPFDATEN",
      "LABEL_LIEFERANT": "Lieferant",
      "LABEL_LIEFERSCHEIN_NUMMER": "Lieferscheinnummer",
      "LABEL_BESTELLNUMMER": "Bestellnummer"
    },
    "DIALOG": {
      "TITEL_EMBALLAGE_AUSWAEHLEN": "Emballage auswählen",
      "TITEL_POSITION_ERLEDIGT_MARKIEREN": "Position als erledigt markieren",
      "TITEL_ANZAHL_ETIKETTEN": "ANZAHL DER PALETTEN-ETIKETTEN",
      "TITEL_WARENUEBERNAHME_WIRD_BEARBEITET": "Diese Warenübernahme wird gerade bearbeitet!",
      "TITEL_WARENUEBERNAHME_ABSCHLIESSEN": "Warenübernahme abschließen",
      "LABEL_WARENUEBERNAHME_ABSCHLIESSEN": "Möchten Sie die Warenübernahme abschließen?",
      "LABEL_WARENUEBERNAHME_WIRD_BEARBEITET": "Achtung, die Warenübernahme wird derzeit von Anwender",
      "LABEL_WARENUEBERNAHME_BEARBEITET": "bearbeitet.",
      "LABEL_DENNOCH_FORTFAHREN": "Möchten Sie dennoch fortfahren?",
      "LABEL_ABBRECHEN": "Abbrechen",
      "ETIKETTEN_LABEL": "Etiketten",
      "LABEL_FORTFAHREN": "Fortfahren",
      "TITEL_ETIKETTEN_DRUCKEN": "Etiketten drucken?"
    },
    "FILTER_SORT": {
      "TITEL_WARENUEBERNAHME_ID": "Warenübernahme-ID",
      "TITEL_LIEFERANT_ID": "Lieferanten-ID",
      "TITEL_LIEFERANT_NUMMER": "Lieferanten-Nummer",
      "TITEL_LIEFERANT_BEZEICHNUNG": "Lieferanten-Bezeichnung",
      "TITEL_LIEFERSCHEIN_NUMMER": "Lieferscheinnummer",
      "TITEL_ANWENDER_BEZEICHNUNG": "Anwender-Bezeichnung",
      "TITEL_BESTELLNUMMER": "Bestellnummer",
      "TITEL_BESTELLUNG_ID": "Bestellungs-ID",
      "TITEL_ANZAHL_BEWEGUNGEN": "Anzahl der Bewegungen"
    }
  }
}
